import { useState, useEffect, useContext, useMemo } from 'react';
import {
  Table,
  Container,
  Button,
  SpaceBetween,
  Header,
  Box,
  Modal as CloudscapeModal,
  Multiselect,
  Input
} from '@cloudscape-design/components';

// models
import { DOCTYPE, documentTableItem, Projects } from '../lib/models/interfaces';
import { useCollection } from '@cloudscape-design/collection-hooks';
// helpers
// dummy data
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { DocumentContext } from '../context/documentContext';
import { UserContext } from '../context/authContext';
import { ProjectForm } from './Components/projectForm';
import { getProjectType } from '../helpers/projectType';
import { ProjectContext } from '../context/projectContext';
import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';
import { manageShare } from '../helpers/manageShareHelpers';
// import { HelpContext } from '../context/helpContext';
import { BreadcrumbsPills } from './Components/shared/backAndHomeButtons';

import { useAlert } from '../context/alertContext';
import { createLogger } from '../helpers/Logger';
import ButtonCollection, {
  ButtonConfig
} from './Components/shared/buttonCollection';
import { AdaptiveModal } from './Components/shared/AdaptiveModal';

const logger = createLogger({ prefix: '[Project]' });

export const ProjectTableView = (props: {}) => {
  const navigate = useNavigate();
  const {
    mainProjects,
    setMainProjects,
    allFolders,
    // getAllProjects,
    selectedProjects,
    setSelectedProjects,
    setSelectedFolder,
    setProjectIdContext
  } = useContext(ProjectContext);
  const { auth, user, users } = useContext(UserContext);
  const { allDocuments, getAllDocs } = useContext(DocumentContext);
  const { setAlert, handleError } = useAlert();
  const [searchParams] = useSearchParams();
  const { projectId } = useParams();
  const [folderModal, setFolderModal] = useState<boolean>(false);
  const [addProjectLoading, setAddProjectLoading] = useState<boolean>(false);
  const [fetching, setFetching] = useState<boolean>(false);
  const [shareModalVisible, setShareModalVisible] = useState<boolean>(false);
  const [selectedShare, setSelectedShare] = useState<OptionDefinition[]>([]);
  const [shareDocLoading, setShareDocLoading] = useState<boolean>(false);
  const [searchDocumentName, setSearchDocumentName] = useState<string>('');
  const [selectedSearchDocument, setSelectedSearchDocument] = useState<
    documentTableItem[]
  >([]);
  const [showKBDocuments, setShowKBDocuments] = useState<boolean>(false);

  const setInfoFromUrl = () => {
    if (projectId) {
      setProjectIdContext(projectId);
    }
    const showNew = searchParams.get('showNew');
    const type = searchParams.get('type');
    const newTypes = [
      'workspace',
      'information_request',
      'policy_document',
      'contract'
    ];
    if (showNew === 'true' && type) {
      if (newTypes.includes(type)) {
        setFolderModal(true);
      }
    }
  };

  useEffect(() => {
    setInfoFromUrl();
    getAllDocs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchDocumentName.length > 0) {
      setShowKBDocuments(false);
      setSelectedProjects([]);
    }
    setSelectedSearchDocument([]);
  }, [searchDocumentName]);

  const canDeleteProject = useMemo(() => {
    if (selectedProjects.length > 0) {
      const projectDocs = allDocuments.filter(
        (ele) => ele.project === selectedProjects[0]?._id
      );
      logger.info('no of docs', projectDocs.length);
      if (projectDocs.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProjects]);

  const createNewProject = async (
    projectName: string,
    projectDescription: string,
    projectType: string
  ) => {
    try {
      setAddProjectLoading(true);
      const createProject = await axios.post(
        `${process.env.REACT_APP_KORU_API}/folder?type=createNewProject`,
        {
          projectName,
          projectDescription,
          projectType,
          owner: user.name
        },
        auth
      );
      // getAllProjects('create new ptv 108');
      getAllDocs();

      setAddProjectLoading(false);
      setFolderModal(false);
      setAlert('Project Created', 'success', 2);
    } catch (e) {
      const error = e as Error;
      handleError(error);
      logger.error('Error', error.message);
    }
  };

  // useEffect(() => {
  //   getAllProjects('auth change ptv 140');
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [auth]);

  const deleteProject = async () => {
    try {
      const results = await axios.post(
        `${process.env.REACT_APP_KORU_API}/folder?type=deleteProject`,
        {
          _id: selectedProjects[0]._id
        },
        auth
      );
      setSelectedProjects([]);
      // getAllProjects('delet project ptv 154');
      getAllDocs();
      setAlert('Project Deleted', 'success', 2);
    } catch (e) {
      const error = e as Error;
      handleError(error);
      logger.error('Error', error.message);
    }
  };

  useEffect(() => {
    if (selectedProjects.length === 0) {
      setSelectedFolder([]);
    } else {
      selectedProjectPermissions();
    }
  }, [selectedProjects]);

  // sharing functions

  const handleShareModalCancel = () => {
    setShareDocLoading(false);
    setShareModalVisible(false);
    setSelectedShare([]);
  };

  const updateShare = async () => {
    if (!selectedProjects) return;
    try {
      setShareDocLoading(true);
      logger.info('original', selectedProjects[0].permissions);
      logger.info('new', selectedShare);
      const getChanges = manageShare(
        selectedProjects[0].permissions.map((ele) => {
          return { value: ele.sub, label: ele.name };
        }),
        selectedShare
      );
      logger.info('changes', getChanges);
      const reqBody = {
        _id: selectedProjects[0]._id,
        remove: getChanges.removedItems.map((ele) => {
          return {
            sub: ele.value,
            action: 'view',
            name: ele.label
          };
        }),
        add: getChanges.addedItems.map((ele) => {
          return {
            sub: ele.value,
            action: 'view',
            name: ele.label
          };
        })
      };
      const response = await axios.post(
        `${process.env.REACT_APP_KORU_API}/share?type=project`,
        reqBody,
        auth
      );
      logger.info('reqBody', reqBody);
      // update the specific documents permissions
      const updatedItem = response.data.result;
      const tempProjects = mainProjects;
      const specificProjectIndex = tempProjects.findIndex(
        (ele) => ele._id === updatedItem?._id
      );
      if (specificProjectIndex !== -1) {
        tempProjects[specificProjectIndex].permissions =
          updatedItem.permissions;
      }
      setMainProjects([...tempProjects]);

      // logger.info('result', response.data);
      getAllDocs();
      setShareDocLoading(false);
      setShareModalVisible(false);
      setSelectedShare([]);
      setSelectedProjects([]);
      setAlert('Project Updated', 'success', 2);
    } catch (e) {
      const error = e as Error;
      handleError(error);
      logger.error('Update error ', error.message);
      if (axios.isAxiosError(error) && error.response?.status === 403) {
        setAlert('You are not authorized to perform this action', 'error', 3);
      }
      setShareDocLoading(false);
      setShareModalVisible(false);
      setSelectedShare([]);
      setSelectedProjects([]);
    }
  };

  const selectedProjectPermissions = () => {
    const permissionsList = selectedProjects[0]!.permissions;
    const tempOptionsList = permissionsList.map((member) => {
      return {
        label: member.name,
        value: member.sub
      };
    });
    setSelectedShare([...tempOptionsList]);
  };

  const emptyState = () => {
    if (mainProjects.length === 0 && !fetching) {
      return (
        <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
          <SpaceBetween size="m">
            <b>No Projects</b>
            <Button onClick={() => setFolderModal(true)}>
              Create Project To Start
            </Button>
          </SpaceBetween>
        </Box>
      );
    }
  };

  const {
    items,
    actions,
    filteredItemsCount,
    collectionProps,
    filterProps
    // paginationProps
  } = useCollection(mainProjects, {
    filtering: {
      empty: <Box>Nothing</Box>,
      noMatch: <Box>No matches</Box>
    },
    // pagination: { pageSize: 15 },
    sorting: {},
    selection: {}
  });

  const handleRowClick = (e: any) => {
    logger.info('row clicked', e.detail.detail.item);
    const clickedProject = e.detail.detail.item as Projects;
    setSelectedProjects([clickedProject]);
    setSelectedFolder([clickedProject.folders[0]]);
    navigate(
      `/app/projects/${clickedProject._id}/folder/${clickedProject.folders[0]}`
    );
  };

  const handleKBRowClick = (e: any) => {
    logger.info('row clicked', e.detail.detail.item);
    const clickedProject = e.detail.detail.item as documentTableItem;

    navigate(
      `/app/projects/${clickedProject.project}/folder/${clickedProject.folder}?fileName=${clickedProject.documentFileName}`
    );
  };

  const buttonsInfo: ButtonConfig[] = useMemo(
    () => [
      {
        label: 'Create Project',
        buttonFunctions: () => setFolderModal(true),
        type: 'main',
        variant: 'normal'
      },
      {
        label: `${showKBDocuments || selectedSearchDocument.length === 1 ? 'Show Document' : 'View Project'}`,
        buttonFunctions: () => {
          if (
            !showKBDocuments &&
            selectedSearchDocument.length === 0 &&
            !(searchDocumentName.length > 0)
          ) {
            navigate(`/app/projects/${selectedProjects[0]._id}/folder/`);
          }
          if (selectedSearchDocument.length === 1) {
            if (showKBDocuments) {
              navigate(
                `/app/projects/${selectedSearchDocument[0].project}/folder/${selectedSearchDocument[0].folder}?fileName=${selectedSearchDocument[0].documentFileName}`
              );
            } else {
              navigate(
                `/app/projects/${selectedSearchDocument[0].project}/folder/${selectedSearchDocument[0].folder}?fileName=${searchDocumentName}`
              );
            }
          }
        },
        type: 'main',
        variant: 'primary'
        // disabled: selectedProjects.length !== 1
      },
      {
        label: `${
          showKBDocuments ? 'Show Projects' : 'Knowledge Base Documents'
        }`,
        buttonFunctions: () => {
          setSelectedSearchDocument([]);
          setShowKBDocuments((prev) => !prev);
        },
        type: 'additional',
        variant: `${showKBDocuments ? 'primary' : 'normal'}`,
        disabled: searchDocumentName.length > 0,
        wrapperText: 'Show all Documents that are part of the Knowledgebase'
      },

      {
        label: 'Delete',
        buttonFunctions: () => {
          deleteProject();
        },
        type: 'additional',
        variant: 'normal',
        disabled:
          allDocuments?.filter((d) => d.project === selectedProjects[0]?._id)
            .length > 0,
        wrapperText: 'Only empty projects can be deleted.'
      },
      {
        label: 'Share',
        buttonFunctions: () => setShareModalVisible(true),
        type: 'additional',
        variant: 'normal',
        disabled:
          selectedProjects.length !== 1 ||
          (!selectedProjects[0]?.permissions.some((p) => p.sub === user.sub) &&
            !user.isAdmin),
        wrapperText: 'Update Project Permissions'
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      selectedProjects,
      showKBDocuments,
      searchDocumentName,
      selectedSearchDocument,
      allDocuments
    ]
  );

  return (
    <>
      <div className="p-2">
        {/* <BackAndHomeButtons
          showBackButton={false}
          currentFolder={null}
          projectId={null}
        /> */}
        <BreadcrumbsPills />
      </div>
      <Container
        data-tour-id="projects-overview"
        header={
          <Header
            variant="h1"
            actions={
              <SpaceBetween direction="horizontal" size="xs">
                <ButtonCollection buttons={buttonsInfo} />
                {/* {searchDocumentName.length < 1 && (
                  <>
                    <Button
                      iconName="share"
                      variant="icon"
                      disabled={
                        !(selectedProjects.length === 1) ||
                        !selectedProjects[0]?.permissions.some(
                          (p) => p.sub === user.sub
                        )
                      }
                      onClick={() => setShareModalVisible(true)}
                      data-tour-id="projectShareButton"
                    />
                    <Button
                      variant={showKBDocuments ? 'primary' : 'normal'}
                      onClick={() => {
                        setShowKBDocuments((prev) => !prev);
                      }}
                    >
                      {showKBDocuments
                        ? 'Show Projects'
                        : 'Knowledge Base Documents'}
                    </Button>
                    <Button
                      disabled={
                        !(selectedProjects && selectedProjects.length > 0)
                      }
                      onClick={() => {
                        // setViewFolder(true);
                        // setSearchParams(`projectId=${selectedProjects[0]._id}`);
                        navigate(
                          `/app/projects/${selectedProjects[0]._id}/folder/`
                        );
                        // setCurrentFolder('');
                      }}
                      data-tour-id="projectViewButton"
                    >
                      View Project
                    </Button>
                    <Button
                      onClick={() => deleteProject()}
                      disabled={canDeleteProject}
                    >
                      Delete Project
                    </Button>
                    <Button
                      data-tour-id="projectButton"
                      onClick={() => setFolderModal(true)}
                      loading={addProjectLoading}
                      variant="primary"
                    >
                      Create Project
                    </Button>
                  </>
                )}
                {searchDocumentName.length > 0 ||
                  (showKBDocuments && (
                    <>
                      <Button
                        onClick={() => {
                          if (showKBDocuments) {
                            navigate(
                              `/app/projects/${selectedSearchDocument[0].project}/folder/${selectedSearchDocument[0].folder}?fileName=${selectedSearchDocument[0].documentFileName}`
                            );
                          } else {
                            navigate(
                              `/app/projects/${selectedSearchDocument[0].project}/folder/${selectedSearchDocument[0].folder}?fileName=${searchDocumentName}`
                            );
                          }
                        }}
                        variant="primary"
                      >
                        Go
                      </Button>
                    </>
                  ))} */}
              </SpaceBetween>
            }
          >
            {showKBDocuments ? 'Knowledge Base Documents' : 'Projects'}
          </Header>
        }
      >
        <div className="p-4 w-[50%]">
          <Input
            onChange={({ detail }) => setSearchDocumentName(detail.value)}
            value={searchDocumentName}
            placeholder="Search for Documents by Name"
          ></Input>
        </div>
        {searchDocumentName.length === 0 && !showKBDocuments && (
          <div
            style={{
              overflow: 'scroll',
              scrollbarWidth: 'none',
              height: '65vh',
              maxHeight: '65vh'
            }}
          >
            <Table
              // onSelectionChange={({ detail }) =>
              //   setSelectedItemsLocal(detail.selectedItemsLocal)
              // }
              stickyHeader
              {...collectionProps}
              onRowClick={(detail) => handleRowClick({ detail })}
              contentDensity="compact"
              variant="borderless"
              items={items}
              selectionType="single"
              // pagination={<Pagination {...paginationProps} />}
              columnDefinitions={[
                {
                  id: 'name',
                  header: 'Project Name',
                  cell: (item: Projects) => item.projectName,
                  sortingField: 'projectName',
                  maxWidth: '400px'
                },
                {
                  id: 'description',
                  header: 'Description',
                  cell: (item: Projects) => item.projectDescription,
                  maxWidth: '200px'
                },
                {
                  id: 'owner',
                  header: 'Owned by',
                  cell: (item: Projects) => item.owner,
                  sortingField: 'owner',
                  maxWidth: '200px'
                },
                {
                  id: 'type',
                  header: <div>Project Type</div>,
                  cell: (item: Projects) => getProjectType(item.projectType),
                  maxWidth: '200px'
                },
                {
                  id: 'date',
                  header: 'Date Created',
                  cell: (item: Projects) =>
                    new Date(item.createdAt).toLocaleDateString(),
                  sortingField: 'date',
                  sortingComparator(a, b) {
                    return (
                      new Date(a.createdAt).getTime() -
                      new Date(b.createdAt).getTime()
                    );
                  }
                },
                {
                  id: 'permission',
                  header: <div data-tour-id="shared">Shared</div>,
                  cell: (item: Projects) =>
                    `${item.permissions.map((ele) => ele.name).join(' ')}`
                }
              ]}
              loadingText="Loading resources"
              empty={emptyState()}
              onSelectionChange={({ detail }) => {
                setSelectedProjects(detail.selectedItems);
              }}
              selectedItems={selectedProjects}
            />
          </div>
        )}
        {searchDocumentName.length > 0 && (
          <div style={{ overflow: 'scroll', scrollbarWidth: 'none' }}>
            <Table
              stickyHeader
              variant="borderless"
              contentDensity="compact"
              items={allDocuments.filter((d) =>
                d.documentFileName.includes(searchDocumentName)
              )}
              selectionType="single"
              columnDefinitions={[
                {
                  id: 'docName',
                  header: 'File Name',
                  cell: (item: documentTableItem) => item.documentFileName,
                  sortingField: 'projectName',
                  maxWidth: '400px'
                },
                {
                  id: 'project',
                  header: 'Project',
                  cell: (item: documentTableItem) => {
                    return (
                      mainProjects.filter((p) => p._id === item?.project)[0]
                        ?.projectName ?? ''
                    );
                  },
                  maxWidth: '200px'
                },
                {
                  id: 'project',
                  header: 'Project',
                  cell: (item: documentTableItem) => {
                    return (
                      allFolders.filter((f) => f._id === item?.folder)[0]
                        ?.folderName ?? ''
                    );
                  },
                  maxWidth: '200px'
                },
                {
                  id: 'status',
                  header: 'Document Status',
                  cell: (item: documentTableItem) => item.status
                }
              ]}
              loadingText="Loading resources"
              empty={emptyState()}
              onSelectionChange={({ detail }) => {
                setSelectedSearchDocument(detail.selectedItems);
              }}
              selectedItems={selectedSearchDocument}
            />
          </div>
        )}
        {searchDocumentName.length === 0 && showKBDocuments && (
          <div style={{ overflow: 'scroll', scrollbarWidth: 'none' }}>
            <Table
              stickyHeader
              variant="borderless"
              onRowClick={(detail) => handleKBRowClick({ detail })}
              contentDensity="compact"
              items={allDocuments.filter((d) => d.searchAble)}
              selectionType="single"
              columnDefinitions={[
                {
                  id: 'docName',
                  header: 'File Name',
                  cell: (item: documentTableItem) => item.documentFileName,
                  sortingField: 'projectName',
                  maxWidth: '300px'
                },
                {
                  id: 'project',
                  header: 'Project',
                  cell: (item: documentTableItem) => {
                    return (
                      mainProjects.filter((p) => p._id === item?.project)[0]
                        ?.projectName ?? ''
                    );
                  },
                  maxWidth: '200px'
                },
                {
                  id: 'project',
                  header: 'Project',
                  cell: (item: documentTableItem) => {
                    return (
                      allFolders.filter((f) => f._id === item?.folder)[0]
                        ?.folderName ?? ''
                    );
                  },
                  maxWidth: '200px'
                },
                {
                  id: 'owner',
                  header: 'Owner',
                  cell: (item: documentTableItem) => item.owner
                },
                {
                  id: 'kbType',
                  header: 'KB Label',
                  cell: (item: documentTableItem) => item.knowledge_base_type
                }
              ]}
              loadingText="Loading resources"
              empty={emptyState()}
              onSelectionChange={({ detail }) => {
                setSelectedSearchDocument(detail.selectedItems);
              }}
              selectedItems={selectedSearchDocument}
            />
          </div>
        )}
      </Container>
      {/* show the new project modal */}
      <AdaptiveModal
        data-tour-id="projectModal"
        visible={folderModal}
        disableContentPaddings
        onDismiss={() => {
          setFolderModal(false);
          // setShowTourEvents({ ...showTourEvents, projectModal: false });
        }}
      >
        <ProjectForm
          createNewProject={createNewProject}
          setFolderModal={setFolderModal}
          projectType={searchParams.get('type')}
        />
      </AdaptiveModal>

      <CloudscapeModal
        // size=""
        visible={shareModalVisible}
        onDismiss={() => handleShareModalCancel()}
        header={'Share Project Access'}
        footer={
          <SpaceBetween size={'s'} direction="horizontal" alignItems="end">
            <Button onClick={() => handleShareModalCancel()}>Cancel</Button>
            <Button onClick={() => updateShare()} loading={shareDocLoading}>
              Save Access
            </Button>
          </SpaceBetween>
        }
      >
        <div
          style={{
            height: '25vh'
          }}
        >
          <p>
            Users you add will get access to all folders and documents in this
            project.
          </p>
          <Multiselect
            onChange={({ detail }) =>
              setSelectedShare([...detail.selectedOptions])
            }
            placeholder="Users"
            selectedOptions={selectedShare}
            options={users.map((ele) => {
              return {
                label: ele.name,
                value: ele.sub
                // disabled:
                //   (ele.sub === user.sub && !user.isAdmin) || !user.isAdmin
              };
            })}
          ></Multiselect>
        </div>
      </CloudscapeModal>
    </>
  );
};
